import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  /* background: rgba(0, 0, 0, 0.8); */
  z-index: 999;
`;
